import { render, staticRenderFns } from "./ContentFrame.vue?vue&type=template&id=652a0c14&scoped=true"
import script from "./ContentFrame.vue?vue&type=script&lang=js"
export * from "./ContentFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a0c14",
  null
  
)

export default component.exports